import React from 'react';
import { Route } from 'react-router-dom';
import UserGuides from './UserGuides';

export const USER_GUIDES_BASE_PATH = '/userGuides';

const UserGuidesRoute = () => {
    return (
        <Route path={USER_GUIDES_BASE_PATH} component={UserGuides} />
    );
};

export default UserGuidesRoute;
